import { atom, useAtom, useSetAtom } from 'jotai';

const FilterDeductionMsgState = atom<Record<string, boolean>>({});

export const useResetFilterDeductionMsg = () => {
  const reset = useSetAtom(FilterDeductionMsgState);
  return () => {
    reset({});
  };
};

export const useFilterDeductionMsgState = (conversationId: string) => {
  const [value, setValue] = useAtom(FilterDeductionMsgState);
  const setV = (v: boolean) => {
    setValue((pre) => {
      return {
        ...pre,
        [conversationId]: v,
      };
    });
  };
  return [!!value[conversationId], setV] as const;
};
